import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import imageCompression from 'browser-image-compression';


function FamilyInfoUpdateClan() {

    const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();

  
const [selectedClan, setSelectedClan] = useState("");
const [selectedTotem, setSelectedTotem] = useState("");
const [familyName, setFamilyName] = useState("");



  
const { data: clanData, isLoading: clanLoading } = useQuery({
  queryKey: ['clans'],
  queryFn: async () => {
    const res = await axios.get(`${API_URL}/reg-signup-clan-api`, {
      withCredentials: true,
    });

    if (res.data.Status === "Success") {
      return res.data;
    }
    throw new Error("No clans found");
  },
  refetchOnMount: true, 
  staleTime: 0,         
  gcTime: 0,     
});

// set default when data loads
useEffect(() => {
  if (clanData?.selectedClanId) {
    setSelectedClan(clanData.selectedClanId.toString());
  }
}, [clanData]);


  // Totems



  const { data: totemData, isLoading: totemLoading } = useQuery({
    queryKey: ["totems", selectedClan],
    enabled: !!selectedClan,
    queryFn: () =>
      axios
        .get(`${API_URL}/reg-signup-totem-api`, {
          params: { clan_id: selectedClan },
          withCredentials: true,
        })
        .then(res => {
          if (res.data.Status === "Success") return res.data;
          throw new Error("No totems found");
        }),
  });
  
  // set default totem when data arrives
  useEffect(() => {
    if (totemData?.selectedTotemId) {
      setSelectedTotem(totemData.selectedTotemId.toString());
    }
  }, [totemData]);



  
const handleClanChange = async (e) => {
  const value = e.target.value;

  if (value === "insert_clan") {
    navigate("/family-info-update-clan-add");
  } else {
    setSelectedClan(value);

    try {
      await axios.put(
        `${API_URL}/update-family-info-clan-selected-api`,
        { clan_id: value },
        { withCredentials: true }
      );
      console.log("Clan updated successfully");
    } catch (error) {
      console.error("Failed to update clan", error);
    }
  }
};


  const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmit = (e) => {
  e.preventDefault();

  if (!familyName || familyName.trim() === "") {
    toast.error("Please enter a family name");
    return;
  }

  setIsSubmitting(true);

  axios
    .put(
      `${API_URL}/update-family-info-clan-totem-api`,
      {
       
        clan_id: selectedClan || null,
        totem_id: selectedTotem || null,
        family_name: familyName.trim(),
      },
      { withCredentials: true }
    )
    .then((res) => {
      if (res.data.Status === "Success") {
        toast.success("Family info updated successfully", { autoClose: 3000 });
      
        //queryClient.invalidateQueries(['familyName']);
      queryClient.setQueryData(['familyName'], familyName.trim());
      navigate('/home');

      } else {
        toast.error(res.data.Message);
      }
    })
    .catch(() => toast.error("An error occurred. Please try again."))
    .finally(() => setIsSubmitting(false));
};
  

return (
  <div className="scrollPageContainer theme-light" style={{ overflow: "visible" }}>
    <div className="main-wrapper" style={{ overflow: "visible" }}>
      {/* start of header */}
      {isSidebarVisible && <Sidebar />}
      <Header toggleSidebar={toggleSidebar} />
      {/* end of header */}

      {/* start of sidebar */}
      <Sidebar show={showSidebar} toggle={toggleSidebar} />
      {/* End of sidebar */}

      {/* start of footerbar */}
      <Footerbar toggleSidebar={toggleSidebar} />
      {/* end of footerbar */}

      <ToastContainer />

      <div className="page-wrapper" style={{ overflow: "visible" }}>
        <div className="content container-fluid" style={{ overflow: "visible" }}>
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 col-xl-7">
              {/* ✅ remove overflow-hidden to avoid clipping dropdowns */}
              <div className="card shadow-sm border-0 rounded-4">
                {/* ✅ compact header */}
                <div
                  className="px-3 py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(116,186,84,0.18), rgba(44,83,61,0.06))",
                    borderBottom: "1px solid rgba(44,83,61,0.12)",
                  }}
                >
                  <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
                    <div>
                      <h5 className="mb-1 fw-bold">Update Your Family Info</h5>
                    </div>

                    <div className="text-end">
                      <div
                        className="badge px-3 py-2 rounded-pill"
                        style={{
                          background: "rgba(116,186,84,0.18)",
                          color: "#2C533D",
                          border: "1px solid rgba(44,83,61,0.18)",
                        }}
                      >
                        Step 2 of 2
                      </div>
                    </div>
                  </div>

                  <div className="mt-2">
                    <div className="progress" style={{ height: 7, borderRadius: 999, background: "rgba(44,83,61,0.12)" }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "100%", background: "linear-gradient(90deg, #74BA54, #2C533D)" }}
                      />
                    </div>
                  </div>
                </div>

                {/* ✅ compact body + extra bottom padding so dropdown has room to open DOWN */}
                <div
                  className="card-body p-3 p-md-4"
                  style={{ overflow: "visible", paddingBottom: 28 }}
                >
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      {/* Clan */}
                      <div className="col-12">
                        <label className="form-label fw-semibold mb-1">
                          Clan <span className="text-muted">(optional)</span>
                        </label>

                        <select
                          className="form-select form-select-sm rounded-3"
                          value={selectedClan}
                          onChange={handleClanChange}
                        >
                          <option value="">Select Clan</option>

                          {clanLoading ? (
                            <option disabled>Loading clans...</option>
                          ) : (
                            clanData?.clans?.map((clan) => (
                              <option key={clan.id} value={clan.id}>
                                {clan.name}
                              </option>
                            ))
                          )}

                          <option value="insert_clan" style={{ fontWeight: 900 }}>
                            + Insert your clan
                          </option>
                        </select>

                      </div>

                      {/* Totem */}
                      <div className="col-12">
                        <label className="form-label fw-semibold mb-1">
                          Totem <span className="text-muted">(optional)</span>
                        </label>

                        <select
                          className="form-select form-select-sm rounded-3"
                          value={selectedTotem}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "insert_totem") {
                              navigate("/family-info-update-totem-add");
                            } else {
                              setSelectedTotem(value);
                            }
                          }}
                          disabled={!selectedClan}
                        >
                          <option value="">
                            {!selectedClan ? "Select clan first" : "Select Totem"}
                          </option>

                          {totemLoading ? (
                            <option disabled>Loading totems...</option>
                          ) : (
                            totemData?.totems?.map((totem) => (
                              <option key={totem.id} value={totem.id}>
                                {totem.name}
                              </option>
                            ))
                          )}

                          <option value="insert_totem" style={{ fontWeight: 900 }}>
                            + Insert your totem
                          </option>
                        </select>

                      </div>

                      {/* Family name */}
                      <div className="col-12">
                        <label className="form-label fw-semibold mb-1">
                          Family Name <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          className="form-control form-control-sm rounded-3"
                          placeholder="Enter Family Name"
                          value={familyName}
                          onChange={(e) => setFamilyName(e.target.value)}
                          onFocus={(e) =>
                            e.target.scrollIntoView({ behavior: "smooth", block: "center" })
                          }
                        />

                      </div>
                    </div>

                    {/* Actions */}
                    <div className="d-flex justify-content-between mt-3">
                      <Link to="/family-info-update" className="btn btn-light border rounded-3 px-3 py-2">
                        Back
                      </Link>

                      <button
                        type="submit"
                        className="btn rounded-3 px-3 py-2 d-inline-flex align-items-center justify-content-center"
                        disabled={isSubmitting}
                        style={{
                          minWidth: 150,
                          background: "linear-gradient(135deg, #74BA54, #2C533D)",
                          border: "none",
                          color: "#fff",
                        }}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            />
                            Updating...
                          </>
                        ) : (
                          "Complete Update"
                        )}
                      </button>
                    </div>

                  </form>
                </div>
              </div>

              <div style={{ height: 8 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);


 
}

export default FamilyInfoUpdateClan;
